import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTokenCache } from '@@client/lib/hooks';
import { useCartLastSaved } from '@@client/cart/cart-hooks';
import { getCart } from '@@client/cart/cart-repo';
import { getCanHomeShip } from './actions';
export default function loadCanHomeShip() {
  var checkoutStore = useSelector(function (state) {
    return state.checkout;
  });
  var cartLastSaved = useCartLastSaved();
  var dispatch = useDispatch();
  var tokenCache = useTokenCache();
  useEffect(function () {
    // already doing, no need to fetch again
    if (checkoutStore.canHomeShip.doing) return;
    var cart = getCart();
    dispatch(getCanHomeShip(tokenCache, Object.values(cart.items).map(function (x) {
      return {
        inventoryId: x.inventoryId,
        partTypeNumber: x.partType
      };
    })));
  }, [cartLastSaved]);
  return null;
}